document.addEventListener("DOMContentLoaded", (e) => {
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  const sideModal = document.querySelector("#description-modal");
  const openSideModalBtns = document.querySelectorAll(".js-open-side-modal");
  openSideModalBtns.forEach((btn) =>
    sideModal.addOpenTrigger("click", btn, btn.dataset.modalContentKey)
  );

  if (isIOS()) {
    document
      .querySelectorAll('[data-modal-selector="#read-extract"]')
      .forEach((button) => button.remove());
    document.querySelector("#read-extract")?.remove();
  }
});
